import { Set } from 'immutable'

import { AddOn } from 'src/marketing/plans/types'

const getPlansAndAddOnsByTitle = <T extends { title: string }>(
  plans: T[],
  adds: AddOn[],
  titles: Set<string>,
): Array<T | AddOn> => {
  return [
    ...plans.filter(plan => titles.contains(plan.title)),
    ...adds.filter(plan => titles.contains(plan.title)),
  ]
}

export default getPlansAndAddOnsByTitle
